import Vue from 'vue'
import App from './App.vue'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css';
import 'normalize.css'
import 'hover.css'

import router from './router'

import {Affix} from 'view-design'
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Affix', Affix);

Vue.config.productionTip = false

Vue.use(Element, {
  size: 'medium' // set element-ui default size
})

new Vue({
  router,
  beforeCreate:() => {
    Vue.prototype.$bus = this
  },
  render: h => h(App),
}).$mount('#app')
